module.exports = {
  systemType: '',
  isApp: false
  // isApp: true
}


// WEBPACK FOOTER //
// ./src/assets/js/global.js